/** Lobby / session sentinel: assign a concrete playable at game start. */
export const RANDOM_CHARACTER_ID = "random";
export function isRandomCharacterId(id) {
    return id === RANDOM_CHARACTER_ID;
}
